import { FC } from "react"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import {
    DiscountType,
    DisplayLabelType,
    OfferDetailsType,
} from "../../../../../../modules/merchant/admin/products/productsTypes"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { TagRounded } from "./Tag"

type StyleProps = Readonly<{
    top: string
    right: string
}>

type OfferTagProps = StyleProps & {
    offerDetails?: OfferDetailsType
}

const useStyles = makeStyles<StyleProps>()((_theme, { top, right }) => ({
    container: {
        position: "absolute",
        top,
        right,
    },
}))

export const OfferTag: FC<OfferTagProps> = ({ offerDetails, top, right }) => {
    const { classes } = useStyles({ top, right })

    if (!offerDetails) return null

    const { discount } = offerDetails

    if (
        !discount ||
        (discount?.displayLabelType &&
            [DisplayLabelType.OLD_NEW_PRICE, DisplayLabelType.LIMITED_ON_SALE].includes(discount?.displayLabelType))
    ) {
        return null
    }

    const getTagText = () => {
        switch (discount.displayLabelType) {
            case DisplayLabelType.SAVE_X:
                if (discount.type === DiscountType.DISCOUNT_PERCENTAGE) {
                    return (
                        <LocalizedStrict
                            id="offer-tag-save-x-percentage"
                            vars={{ amount: discount?.percentage?.amount || 0 }}
                        >
                            <>
                                `${discount?.percentage?.amount}% off / Spar ${discount?.percentage?.amount}%`
                            </>
                        </LocalizedStrict>
                    )
                } else if (discount.type === DiscountType.DISCOUNT_PRICE) {
                    return (
                        <LocalizedStrict id="offer-tag-save-x-price" vars={{ amount: discount?.price?.amount || 0 }}>
                            <>`Save ${discount.price?.amount} kr`</>
                        </LocalizedStrict>
                    )
                }
                break
            case DisplayLabelType.GOOD_PRICE:
                return (
                    <LocalizedStrict id="offer-tag-good-price">
                        <>Good price</>
                    </LocalizedStrict>
                )
            case DisplayLabelType.GREAT_OFFER:
                return (
                    <LocalizedStrict id="offer-tag-great-offer">
                        <>Great offer</>
                    </LocalizedStrict>
                )
            case DisplayLabelType.BUY_NOW:
                return (
                    <LocalizedStrict id="offer-tag-buy-now">
                        <>Buy now</>
                    </LocalizedStrict>
                )
            case DisplayLabelType.DISCOUNT:
                return (
                    <LocalizedStrict id="offer-tag-discount">
                        <>Discount</>
                    </LocalizedStrict>
                )
            case DisplayLabelType.WEEK_OFFER:
                return (
                    <LocalizedStrict id="offer-tag-week-offer">
                        <>Week's offer</>
                    </LocalizedStrict>
                )
            case DisplayLabelType.DAY_OFFER:
                return (
                    <LocalizedStrict id="offer-tag-day-offer">
                        <>Today's offer</>
                    </LocalizedStrict>
                )
            default:
                return null
        }
    }

    const tagText = getTagText()
    if (!tagText) return null

    return (
        <Box className={classes.container}>
            <TagRounded>{tagText}</TagRounded>
        </Box>
    )
}
